import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sticky top-20 flex flex-col gap-3" }
const _hoisted_2 = { class: "bg-white rounded-md border border-gray-200 p-4 flex flex-col" }
const _hoisted_3 = { class: "flex items-start justify-between mb-4" }
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "text-base font-semibold text-gray-900 mb-1" }
const _hoisted_6 = { class: "text-[11px] text-gray-500 leading-relaxed pr-2" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "mb-2 shrink-0" }
const _hoisted_9 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_10 = { class: "truncate" }
const _hoisted_11 = ["onClick", "onContextmenu"]
const _hoisted_12 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_13 = { class: "truncate" }
const _hoisted_14 = {
  key: 0,
  class: "shrink-0"
}
const _hoisted_15 = { class: "flex items-center gap-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateFolderComponent = _resolveComponent("CreateFolderComponent")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_Squares2X2Icon = _resolveComponent("Squares2X2Icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_FolderContextMenuComponent = _resolveComponent("FolderContextMenuComponent")!
  const _component_DeleteFolderConfirmationModalComponent = _resolveComponent("DeleteFolderConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CreateFolderComponent, {
      open: _ctx.showCreateFolderForm,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateFolderForm = false)),
      "gallery-slug": _ctx.gallerySlug
    }, null, 8, ["open", "gallery-slug"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('folders.title')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('folders.tip_text')), 1)
          ]),
          (_ctx.folders.length > _ctx.compactThreshold)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showCreateFolderForm = true), ["prevent"])),
                class: "p-1.5 bg-gray-50 text-gray-600 hover:text-gray-900 hover:bg-gray-100 border border-gray-200 rounded-md transition-colors shrink-0 cursor-pointer",
                title: _ctx.$t('folders.create_folder')
              }, [
                _createVNode(_component_PlusIcon, { class: "w-4 h-4" })
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectFolder(null)), ["prevent"])),
            class: _normalizeClass([
                        'w-full flex items-center justify-between px-2.5 py-1.5 text-sm font-medium border rounded-md transition-colors group',
                        _ctx.selectedFolder === null
                            ? 'bg-gray-100 border-gray-200 text-gray-900'
                            : 'bg-white hover:bg-gray-50 border-gray-200 text-gray-600 hover:text-gray-900'
                    ])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Squares2X2Icon, {
                class: _normalizeClass([
                            'w-4 h-4 shrink-0 transition-colors',
                            _ctx.selectedFolder === null ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'
                        ])
              }, null, 8, ["class"]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('files.all_files')), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass([
                        'text-xs font-semibold shrink-0 transition-colors',
                        _ctx.selectedFolder === null ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'
                    ])
            }, _toDisplayString(_ctx.gallery.photos_count), 3)
          ], 2)
        ]),
        _createVNode(_component_draggable, {
          modelValue: _ctx.sortedFolders,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortedFolders) = $event)),
          onStart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drag=true)),
          onEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag=false)),
          "item-key": "id",
          tag: "nav",
          class: "space-y-0.5 overflow-y-auto pr-1 -mr-1 flex-1 pb-1 max-h-[60vh]",
          "drag-class": "sortable-selected-moving"
        }, {
          item: _withCtx(({element}) => [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.selectFolder(element)), ["prevent"]),
              onContextmenu: _withModifiers(($event: any) => (_ctx.showContextMenuForFolder(element, $event)), ["prevent"]),
              class: _normalizeClass([
                            'w-full flex items-center justify-between px-2.5 py-1.5 text-sm font-medium rounded-md transition-colors group',
                            (_ctx.selectedFolder && _ctx.selectedFolder.id === element.id)
                                ? 'bg-gray-100 text-gray-900'
                                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                        ])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  class: "w-1.5 h-1.5 rounded-full shrink-0",
                  style: _normalizeStyle({backgroundColor: element.color})
                }, null, 4),
                _createElementVNode("span", _hoisted_13, _toDisplayString(element.title), 1),
                (element.is_hidden || element.is_hidden_by_client)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "🫣"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass([
                            'text-xs font-medium shrink-0',
                            (_ctx.selectedFolder && _ctx.selectedFolder.id === element.id) ? 'text-gray-600' : 'text-gray-400 group-hover:text-gray-500'
                        ])
              }, _toDisplayString(element.photos_count), 3)
            ], 42, _hoisted_11)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.folders.length <= _ctx.compactThreshold)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showCreateFolderForm = true), ["prevent"])),
              class: "mt-2 w-full flex items-center justify-center gap-1.5 px-3 py-1.5 bg-white border border-royal-blue-200 hover:bg-royal-blue-50 hover:border-royal-blue-300 text-royal-blue-700 rounded-md text-xs font-medium transition-colors cursor-pointer shrink-0"
            }, [
              _createVNode(_component_PlusIcon, { class: "w-3.5 h-3.5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('folders.create_folder')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.gallery.deleted_count > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.selectTrashFolder()), ["prevent"])),
            class: _normalizeClass([
                'w-full flex items-center justify-between px-4 py-2.5 text-sm font-medium rounded-md border transition-colors group shrink-0',
                _ctx.selectedFolder?.slug == 'trash'
                    ? 'bg-red-50 border-red-200 text-red-700'
                    : 'bg-white border-gray-200 text-gray-600 hover:text-red-600 hover:bg-red-50 hover:border-red-200'
            ])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_TrashIcon, {
                class: _normalizeClass([
                    'w-4 h-4 transition-colors',
                    _ctx.selectedFolder?.slug == 'trash' ? 'text-red-500' : 'text-gray-400 group-hover:text-red-500'
                ])
              }, null, 8, ["class"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('files.trashed_files')), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass([
                'text-xs font-semibold transition-colors',
                _ctx.selectedFolder?.slug == 'trash' ? 'text-red-500' : 'text-gray-400 group-hover:text-red-500'
            ])
            }, _toDisplayString(_ctx.gallery.deleted_count), 3)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.contextMenuFolder)
      ? (_openBlock(), _createBlock(_component_FolderContextMenuComponent, {
          key: 0,
          folder: _ctx.contextMenuFolder as any,
          "is-visible": _ctx.showContextMenu,
          position: _ctx.contextMenuPosition,
          onClose: _ctx.closeContextMenu,
          onEdit: _ctx.handleEditFolder,
          onDelete: _ctx.handleDeleteFolder,
          onCopyLink: _ctx.handleCopyLink
        }, null, 8, ["folder", "is-visible", "position", "onClose", "onEdit", "onDelete", "onCopyLink"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DeleteFolderConfirmationModalComponent, {
      open: _ctx.isDeletingConfirmation !== null,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDeletingConfirmation = null)),
      onConfirmAction: _ctx.confirmDeleteFolder,
      title: _ctx.$t('folders.delete_confirmation_title'),
      message: _ctx.$t('folders.delete_confirmation_message'),
      "second-message": _ctx.$t('folders.delete_confirmation_second_message'),
      "button-text": _ctx.$t('folders.delete_confirmation_button')
    }, null, 8, ["open", "onConfirmAction", "title", "message", "second-message", "button-text"])
  ], 64))
}